import PropTypes from 'prop-types'

// Default styles for each heading level
const headingStyles = {
  h1: 'text-4xl font-bold text-white mb-8',
  h2: 'text-xl font-semibold text-white mb-4',
  h3: 'text-lg font-semibold text-white mb-3',
  h4: 'text-base font-semibold text-white mb-2',
  h5: 'text-sm font-semibold text-white mb-2',
  h6: 'text-xs font-semibold text-white mb-1',
}

// Generic Heading component
export const Heading = ({ level = 'h2', children, className = '', ...props }) => {
  const Component = level
  const baseStyles = headingStyles[level] || headingStyles.h2

  return (
    <Component className={`${baseStyles} ${className}`.trim()} {...props}>
      {children}
    </Component>
  )
}

Heading.propTypes = {
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

// Convenience components for each heading level
export const H1 = ({ children, className = '', ...props }) => (
  <h1 className={`${headingStyles.h1} ${className}`.trim()} {...props}>
    {children}
  </h1>
)

H1.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const H2 = ({ children, className = '', ...props }) => (
  <h2 className={`${headingStyles.h2} ${className}`.trim()} {...props}>
    {children}
  </h2>
)

H2.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const H3 = ({ children, className = '', ...props }) => (
  <h3 className={`${headingStyles.h3} ${className}`.trim()} {...props}>
    {children}
  </h3>
)

H3.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const H4 = ({ children, className = '', ...props }) => (
  <h4 className={`${headingStyles.h4} ${className}`.trim()} {...props}>
    {children}
  </h4>
)

H4.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const H5 = ({ children, className = '', ...props }) => (
  <h5 className={`${headingStyles.h5} ${className}`.trim()} {...props}>
    {children}
  </h5>
)

H5.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export const H6 = ({ children, className = '', ...props }) => (
  <h6 className={`${headingStyles.h6} ${className}`.trim()} {...props}>
    {children}
  </h6>
)

H6.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default Heading
